import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import qp from 'query-parse';
import BaseRequestsPaginationPage from '../../../BaseRequestsPaginationPage';
import GeneralTableRow from '../../../../components/user/table/row';
import InfoTooltip from '../../../../components/common/tooltip/info';
import Loading from '../../../../components/common/loading';
import dashboardContainer from '../../../../containers/user/dashboard';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import cookieAndLocalStorage from "../../../../helpers/cookieAndLocalStorage";

class DashboardPage extends React.Component {
  constructor(props) {
    super(props);

    this.changeFilter = this.changeFilter.bind(this);

    this.actionButtonEvents = {
      deleteRequest: (groupId, harcirahId) => {
        this.props.deleteRequest(groupId, harcirahId);
      },
      renderPage: async () => {
        await this.callFilterAfterReject();
      }
    };
    this.state = {
      requestStatus: props.requestStatus
    };
  }
  async componentDidMount() {
    const { language,isActive,isCheckToken } = this.props;
    i18next.changeLanguage(language)
    if ( isActive === true ){
      await isCheckToken();
    }
    if(isActive === false){
      cookieAndLocalStorage()
    }
  }

  async componentWillMount(){
    const { isCheckToken,isActive } = this.props;
    if ( isActive === true ){
      await isCheckToken();
    }
    if(isActive === false){
      cookieAndLocalStorage()
    }
  }


  async callFilterAfterReject() {
    const currentQuery = qp.toObject(this.props.location.search.substring(1));

    const filter = {
      month: currentQuery.month ? currentQuery.month : 0,
      year: currentQuery.year ? currentQuery.year : 0,
      requestStatus: currentQuery.requestStatus
        ? currentQuery.requestStatus
        : 'all',
      page: this.props.match.params.page,
    };

    await this.changeFilter(filter);
  }

  async changeFilter(filter) {
    const {
      month, year, page, requestStatus,
    } = filter;
    const { fetchRequests } = this.props;

    this.setState({ requestStatus });

    await fetchRequests({
      month, year, activePage: page, requestStatus, rowCount: 10,
    });
  }

  render() {
    const { requestStore, t } = this.props;

    return (
      <div>
      <BaseRequestsPaginationPage
        filterOptionValue="employee"
        changeFilter={this.changeFilter}
      >
       <div className="col-md-12">
          <div className="card">
            <div className="header">
              <h4 className="title">
                                {t("yourRequests")}
              </h4>
            </div>
            <div className="content table-responsive table-full-width">
              <Loading loading={requestStore.loading} rows={5} colSpan={9}>
                <div className="requests">
                  <div className="requests-column">
                    <div className="row">
                      <div className="col-md-1" />
                      <div className="col-md-1">
                        <h5>
                                                    {t("status")}
                        </h5>
                      </div>
                      <div className="col-md-2">
                        <h5>
                                                   {t("travelDate")}
                        </h5>
                      </div>
                      <div className="col-md-2">
                        <h5>
                                                    {t("reasonForTravel")}
                        </h5>
                      </div>
                      <div className="col-md-2">
                        <h5>
                                                    {t("cityCounty")}
                        </h5>
                      </div>
                      <div className="col-md-1">
                        <InfoTooltip info= {t("travelExpensesGross")}>
                          <h5>
                                                        {t("travelExpensesGross")}
                          </h5>
                        </InfoTooltip>
                      </div>
                      <div className="col-md-1">
                        <InfoTooltip info={t("individualAccommodationNet")}>
                          <h5>
                                                        {t("individualAccommodationNet")}
                          </h5>
                        </InfoTooltip>
                      </div>
                      <div className="col-md-2">
                        <h5>
                                                    {t("transaction")}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div className="requests-content">
                    {this.props.requestStore.requests.map(request => (
                      <GeneralTableRow
                        actionButtonEvents={this.actionButtonEvents}
                        lastBusinessDayOfMonth={this.props.requestStore.lastBusinessDayOfMonth}
                        key={request.group_id}
                        select={this.props.selectRequest}
                        request={request.harcirah[0]}
                        group_id={request.group_id}
                        subRequest={request.harcirah}
                        requestStatus={this.state.requestStatus}
                      />
                    ))}
                  </div>
                </div>
              </Loading>
            </div>
          </div>
        </div>
      </BaseRequestsPaginationPage>
      </div>
    );
  }
}

export default withNamespaces()(withRouter(connect(...dashboardContainer)(DashboardPage)));



// WEBPACK FOOTER //
// ./src/pages/travel-expense/detail/user/index.js